import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import { useLoggedOutRetailerNodes } from "./useLoggedOutRetailerNodes";
export var useLoggedOutRetailerNodesL1 = function useLoggedOutRetailerNodesL1() {
  var loggedOutRetailerNodes = useLoggedOutRetailerNodes();
  return Object.values(loggedOutRetailerNodes.L1).map(function (issue) {
    return {
      label: issue,
      value: issue
    };
  });
};
export var useLoggedOutRetailerNodesL2 = function useLoggedOutRetailerNodesL2() {
  var loggedOutRetailerNodes = useLoggedOutRetailerNodes();
  return Object.values(loggedOutRetailerNodes.L2).map(function (issue) {
    return {
      label: issue,
      value: issue
    };
  });
};